<section class="container">
<div [innerHTML]="data.htmlContent"></div>
</section>